module.exports = __webpack_public_path__ + "static/demo-screen-1-6aafd90e0d9f72eb42039d8df66b3f9c.jpg";